/*
*  Site copy & links. The intro text is word-for-word from the previous site.
*  Episodes are in seasons.js.
*/

export const ROUTES = {
  HOME: "/",
};

export const INTRO = {
  INVITATION: "Art is not just something to be glanced at - it is meant to be engaged with, wrestled with, and absorbed. ARTdacity is my invitation to listeners to slow down, look longer, and listen more intently to the stories that contemporary African artists are telling us. In a world consumed by the fleeting nature of digital content, this podcast is a call to reclaim presence - to step away from screens and immerse ourselves in the depth and intention of African art.",
  WHY: "Why? Because contemporary African art is not just an aesthetic movement; it is a revolution of identity, a reclamation of narrative, and a force that is reshaping the global artistic landscape. Too often, these voices are underrepresented, their works admired but not deeply considered. ARTdacity seeks to change that. Through conversations, insights, and storytelling, this podcast will bridge the gap between the artist and the audience, making their work not just seen but felt.",
  CORE: "At its core, ARTdacity is a love letter - to the artists who dare, to the collectors who cherish, and to the curious minds willing to engage beyond the surface. It is about celebrating the impact of African art as it carves out space on the global stage, slowly but undeniably. This podcast is an act of devotion: to art, to identity, and to the audacity it takes to create.",
};

//Where to listen. "scale" is the logo's height relative to the row it sits in (the logos have different shapes)
export const PLATFORMS = [
  {
    name: "Apple Podcasts",
    href: "https://podcasts.apple.com/za/podcast/artdacity/id1796133269",
    icon: "/images/apple-podcasts.png",
    width: 140,
    height: 140,
    scale: 1,
  },
  {
    name: "YouTube",
    href: "https://www.youtube.com/@artdacitywithjo-ann",
    icon: "/images/youtube.png",
    iconOnDark: "/images/youtube-white.png",
    width: 647,
    height: 140,
    scale: 0.38,
  },
  {
    name: "Spotify",
    href: "https://open.spotify.com/show/5OZamS1iOtIc4zomNLk2jz",
    icon: "/images/spotify.png",
    width: 182,
    height: 140,
    scale: 0.88,
  },
];

export const LINKS = {
  TAPX: "https://tap-x.com/",
};
